import is_localhost from "./class_is_localhost";

export default class class_change_img {

    change_img(img, store){
        let width = window.innerWidth 
        if (typeof img === 'string' || img instanceof String)
        img = img.replace("D.jpg", "R.jpg");
        if (width > 1025) {
            this.change_img_desktop(img, store);
            this.change_img_mobile(img, store);
            this. SETOCCHIODESKTOP(store);
        }else{
            this.change_img_desktop(img, store);
            this.change_img_mobile(img, store);
            this. SETOCCHIOMOBILE(store);
        }
     
    }

    change_img_desktop(img, store){
        let el = document.getElementById("img-splash").querySelectorAll("img");
        el[0].setAttribute("src", img);
        el[0].setAttribute("data_src", img);
        el[0].setAttribute("class", 'animation');
        el[0].setAttribute('title',  store.product_store.CODICE_UNIVOCO);
        el[0].setAttribute('alt',  store.product_store.CODICE_UNIVOCO);
        let ur = new is_localhost();
        let url = ur.return_url_website();
        el[0].setAttribute('onerror',  "this.src='"+url+"risorse/prodotto/IMGNOTFOUND.jpg'");
        setTimeout(() => {
            try{
                if (el[0].classList.contains('animation')) {
                    el[0].classList.remove('animation');
                }    
            }catch(e){
                console.info(e);
            }
        }, 2000)
    }

    SETOCCHIODESKTOP(store){
        let el = document.getElementById("img-splash").querySelectorAll("img");
        var insertedContent = document.querySelector(".occhio-centrato");
        if (insertedContent) {
            insertedContent.parentNode.removeChild(insertedContent);
        }
        el[0].insertAdjacentHTML('afterend', store.occhio.occhio);
        let el_occhio = document.getElementById("occhio-centrato").querySelectorAll("a");
        let index = 4;
        if (store.linkmuseo_l.includes(window.descrizione.sku)) {
             index = store.linkmuseo[window.descrizione.sku];
        }
        if (store.linkspecifici.includes(store.product_store.CODICE_UNIVOCO)){
          index = store.linkspecifici_obj[store.product_store.CODICE_UNIVOCO];
        }
        el_occhio[0].setAttribute('href', 'https://vistosi.it/vistosivirtualmuseum/index.htm?media-index='+index);
        if (!index){
            el_occhio[0].setAttribute("class", 'occhi_nascosto');
            el_occhio[0].setAttribute('href', '');
            el_occhio[0].setAttribute('style', '    pointer-events: none; opacity: 0.01;');
          }else{
            el_occhio[0].classList.remove('occhi_nascosto');
            el_occhio[0].setAttribute('style', '    ');
          }
    }
    SETOCCHIOMOBILE(store){
        let el = document.getElementById("img-splash").querySelectorAll("img");
                  var insertedContent = document.querySelector(".occhio-centrato-mobile");
                  if (insertedContent) {
                      insertedContent.parentNode.removeChild(insertedContent);
                  }
                  var insertedContent2 = document.querySelector(".occhio-centrato");
                  if (insertedContent2) {
                      insertedContent2.parentNode.removeChild(insertedContent2);
                  }
                  el[0].insertAdjacentHTML('afterend', store.occhio.occhio);
                  let el_occhio = document.getElementById("occhio-centrato").querySelectorAll("a");
                  let index = 4;
                  if (store.linkmuseo_l.includes(window.descrizione.sku)) {
                       index = store.linkmuseo[window.descrizione.sku];
                  }
                  if (store.linkspecifici.includes(store.product_store.CODICE_UNIVOCO)){
                    index = store.linkspecifici_obj[store.product_store.CODICE_UNIVOCO];
                  }
                  el_occhio[0].setAttribute('href', 'https://vistosi.it/vistosivirtualmuseum/index.htm?media-index='+index);
                  if (!index){
                      el_occhio[0].setAttribute("class", 'occhi_nascosto');
                      el_occhio[0].setAttribute('href', '');
                      el_occhio[0].setAttribute('style', '    pointer-events: none; opacity: 0.01;');
                    }else{
                        el_occhio[0].classList.remove('occhi_nascosto');
                        el_occhio[0].setAttribute('style', '    ');
                  }
    }

    
    change_img_mobile(img, store){
        let el = document.getElementById("img-splash-mobile").querySelectorAll("img");
        el[0].setAttribute("src", img);
        el[0].setAttribute("class", 'animation');
        el[0].setAttribute('title',  store.product.id);
        el[0].setAttribute('alt',  store.product.id);
        setTimeout(() => {
            try{
                if (el[0].classList.contains('animation')) {
                    el[0].classList.remove('animation');
                }    
            }catch(e){
                console.info(e)
            }
        }, 2000)
    }

}